// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1fL_S","rightAdornment":"Header_rightAdornment__2baZn"};